import '../assets/styles/App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

function IDCard({}) {
    // get device width
    const [searchParams, setSearchParams] = useSearchParams();
    const [cardInfo, setCardInfo] = useState({
        cardLocation: '',
        cardName: '',
        cardBirthday: '',
        cardIssueDate: '',
        cardProfileImage: '',
        cardSignatureImage: '',
    });
    const [cardProfileImage, setCardProfileImage] = useState('');
    const [cardColor, setCardColor] = useState('');
    const [flip, setFlip] = useState(false);
    const [loading, setLoading] = useState(true);
    const [reveal, setReveal] = useState(false);

    const cardId = searchParams.get('cardId');

    useEffect(() => {
        const getCardInfo = async () => {
            // console.log(cardId);

            const url = `${process.env.REACT_APP_API_URL}/getTicketAdmin`;

            const config = {
                headers: {
                    Authorization:
                        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI0ODVmMmNlMC1hMDhlLTQzZDAtYjIzZi04MTIxYjZhMjc5ZWEiLCJlbWFpbCI6ImRvYmJ5QHNwYWRlNi5kZXYiLCJpYXQiOjE2Nzk2NDc2OTIsImV4cCI6NDgwMzg1MDA5Mn0.gs8leM1-YSdQLevOhf2P5SrfkXX9xzCA2IPdRtPVFCE',
                },
            };

            const data = {
                ticketId: cardId,
            };
            setLoading(true);
            axios
                .post(url, data, config)
                .then((res) => {
                    if (res.data.ticketType.N === '3') {
                        // split custom data by ,
                        let data = res.data;

                        let exhibitData = JSON.parse(res.data.exhibitData.S);
                        setCardColor(exhibitData.cardColor);
                        // setCardColor('purple');

                        let tmpData = {
                            cardLocation: data.cardLocation?.S,
                            cardName: data.cardName?.S,
                            cardBirthday: data.birthday?.S,
                            cardIssueDate: data.issueDate?.S,
                            cardProfileImage: data.imageUrl?.S,
                            cardSignatureImage: data.signatureImageUrl?.S,
                        };
                        setCardProfileImage(data.imageUrl?.S);
                        // console.log(tmpData);
                        setCardInfo(tmpData);

                        setLoading(false);
                    }
                })
                .catch((error) => console.log(error));
        };
        if (
            searchParams.get('cardId') !== null &&
            searchParams.get('cardId') !== undefined
        ) {
            getCardInfo();
        }
    }, []);

    let navigate = useNavigate();

    const routeChange = (isInternal, path, e) => {
        e.preventDefault();
        if (isInternal) {
            let newPath = path;
            navigate(newPath);
        } else {
            window.open(path);
        }
    };

    const flipCard = () => {
        setFlip(!flip);
    };

    const revealCard = () => {
        setReveal(true);
    };

    if (cardId === null || cardId === undefined) {
        return;
    }

    return (
        <div
            className='id-card-container'
            style={{
                width: '100vw',
                // minHeight: '100vh',
                // overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor:
                    cardColor === 'pink'
                        ? '#FBD7E5'
                        : cardColor === 'purple'
                        ? '#DBCEE0'
                        : cardColor === 'blue'
                        ? '#C6E6F3'
                        : cardColor === 'yellow'
                        ? '#FFF8CC'
                        : cardColor === 'green'
                        ? '#D0EAD0'
                        : '#fff',
                fontFamily: 'DungGeunMo',
            }}
        >
            <div
                style={{
                    textAlign: 'center',
                    position: 'absolute',
                    top: '10px',
                }}
            >
                <img
                    style={{ width: '100px' }}
                    src={require('../assets/cards/logo.png')}
                />
            </div>
            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    LOADING
                </div>
            ) : (
                <>
                    {!reveal ? (
                        <div
                            style={{
                                top: '250px',
                                position: 'absolute',
                                left: '0',
                                right: '0',
                                margin: 'auto',
                                width: 'fit-content',
                                textAlign: 'center',
                            }}
                        >
                            모바일 ID 카드를 보려면 아래 버튼을
                            <br />
                            눌러 주세요
                            <div
                                onClick={() => {
                                    revealCard();
                                }}
                                className='flip-button'
                                style={{ top: '50px' }}
                            >
                                SHOW ID CARD
                            </div>
                        </div>
                    ) : reveal && cardColor !== '' && !flip ? (
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <div
                                className='card-front-image'
                                style={{
                                    textAlign: 'center',
                                    position: 'absolute',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    zIndex: '1',
                                    // marginTop: '110px',
                                    // transform: 'translateY(-50%)',
                                }}
                            >
                                <img
                                    style={{
                                        width: '300px',
                                        border: '1px solid #b8b8b8',
                                        borderRadius: '18px',
                                        boxShadow:
                                            '0px 0px 10px 0px rgba(0,0,0,0.45)',
                                        margin: 'auto',
                                        // transform: 'translateX(-150px)',
                                    }}
                                    src={require(`../assets/cards/${cardColor}-front.png`)}
                                />
                            </div>

                            <div>
                                <img
                                    className='card-profile-image'
                                    style={{
                                        position: 'absolute',
                                        width: '197px',
                                        left: '0',
                                        right: '0',
                                        margin: 'auto',
                                        zIndex: '3',
                                    }}
                                    src={cardProfileImage}
                                />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    position: 'absolute',
                                    width: 'fit-content',
                                }}
                                className='card-name'
                            >
                                <div style={{ width: '122px' }}></div>
                                <div className='card-info-text'>
                                    {cardInfo.cardName}
                                </div>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    position: 'absolute',
                                    width: 'fit-content',
                                }}
                                className='card-birthday'
                            >
                                <div style={{ width: '122px' }}></div>
                                <div className='card-info-text'>
                                    {cardInfo.cardBirthday}
                                </div>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    position: 'absolute',
                                    width: 'fit-content',
                                }}
                                className='card-location'
                            >
                                <div style={{ width: '122px' }}></div>
                                <div className='card-info-text'>
                                    {cardInfo.cardLocation}
                                </div>
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    position: 'absolute',
                                    width: 'fit-content',
                                }}
                                className='card-issuedate'
                            >
                                <div style={{ width: '122px' }}></div>
                                <div className='card-info-text'>
                                    {cardInfo.cardIssueDate}
                                </div>
                            </div>

                            <div
                                onClick={() => {
                                    flipCard();
                                }}
                                className='flip-button'
                            >
                                FLIP
                            </div>
                        </div>
                    ) : reveal && cardColor !== '' && flip ? (
                        <div style={{ width: '100%', height: '100%' }}>
                            <div
                                className='card-back-image'
                                style={{
                                    textAlign: 'center',
                                    position: 'absolute',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    zIndex: '1',
                                    // marginTop: '110px',
                                    // transform: 'translateY(-50%)',
                                }}
                            >
                                <img
                                    style={{
                                        width: '300px',
                                        border: '1px solid #b8b8b8',
                                        borderRadius: '18px',
                                        boxShadow:
                                            '0px 0px 10px 0px rgba(0,0,0,0.45)',
                                        margin: 'auto',
                                        // transform: 'translateX(-150px)',
                                    }}
                                    src={require(`../assets/cards/${cardColor}-back.png`)}
                                />
                            </div>

                            <div
                                className='card-signature-image'
                                style={{
                                    position: 'absolute',
                                    width: 'fit-content',
                                    left: '0',
                                    right: '0',
                                    margin: 'auto',
                                    display: 'flex',
                                    zIndex: '3',
                                }}
                            >
                                <div style={{ width: '35px' }}></div>
                                <img
                                    style={{
                                        width: '188px',
                                    }}
                                    src={cardInfo.cardSignatureImage}
                                />
                            </div>
                            <div
                                onClick={() => {
                                    flipCard();
                                }}
                                className='flip-button'
                            >
                                FLIP
                            </div>
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
}

export default IDCard;
